// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'play-solid';

export const Component = () => (
  <path d='m20.235 13.153-14.75 8.334a.963.963 0 0 1-.527.143.946.946 0 0 1-.67-.287.946.946 0 0 1-.288-.67V4.006a.98.98 0 0 1 .287-.719.943.943 0 0 1 .67-.287c.097 0 .288.048.527.191l14.751 8.334c.288.24.431.527.431.814 0 .383-.143.67-.43.814Z' />
);

export const viewBox = '0 0 25 25';
